export function to(promise) {
    return promise.then(data => {
       return [null, data];
    })
    .catch(err => [err]);
 }


// WEBPACK FOOTER //
// ./src/_helpers/to.util.js